// source: api/workspace.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var user_proto_pb = require('../user_proto_pb.js');
goog.object.extend(proto, user_proto_pb);
var workspace_role_proto_pb = require('../workspace_role_proto_pb.js');
goog.object.extend(proto, workspace_role_proto_pb);
var workspace_default_settings_proto_pb = require('../workspace_default_settings_proto_pb.js');
goog.object.extend(proto, workspace_default_settings_proto_pb);
var api_user_pb = require('../api/user_pb.js');
goog.object.extend(proto, api_user_pb);
var api_device_pb = require('../api/device_pb.js');
goog.object.extend(proto, api_device_pb);
var style_proto_pb = require('../style_proto_pb.js');
goog.object.extend(proto, style_proto_pb);
var timestamp_proto_pb = require('../timestamp_proto_pb.js');
goog.object.extend(proto, timestamp_proto_pb);
goog.exportSymbol('proto.somewear.api.v1.ApplyDefaultSettingsRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.ArchiveMembersRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.ArchiveMembersResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.ArchiveWorkspaceRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.CreateResourceAccountRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.CreateResourceAccountResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.CreateWorkspaceKeyApiRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.CreateWorkspaceKeyApiResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.DeleteWorkspaceRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetDefaultSettingsRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetDefaultSettingsResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.InviteMembersRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.InviteMembersResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.IssueWorkspaceInviteTokenRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.IssueWorkspaceInviteTokenResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.JoinWorkspaceByInviteRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.JoinWorkspaceByInviteResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.LeaveWorkspaceRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.RemoveMembersRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.RemoveMembersResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.ToggleWorkspaceIntegrationRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.TransferDeviceRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.TransferDevicesRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.TransferDevicesResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.UpdateDefaultSettingsRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.UpdateWorkspaceAccessResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.UpdateWorkspaceRoleRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.UpdateWorkspaceRoleResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.InviteMembersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.InviteMembersRequest.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.InviteMembersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.InviteMembersRequest.displayName = 'proto.somewear.api.v1.InviteMembersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.InviteMembersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.InviteMembersResponse.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.InviteMembersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.InviteMembersResponse.displayName = 'proto.somewear.api.v1.InviteMembersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.ArchiveMembersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.ArchiveMembersRequest.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.ArchiveMembersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.ArchiveMembersRequest.displayName = 'proto.somewear.api.v1.ArchiveMembersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.ArchiveMembersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.ArchiveMembersResponse.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.ArchiveMembersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.ArchiveMembersResponse.displayName = 'proto.somewear.api.v1.ArchiveMembersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.RemoveMembersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.RemoveMembersRequest.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.RemoveMembersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.RemoveMembersRequest.displayName = 'proto.somewear.api.v1.RemoveMembersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.RemoveMembersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.RemoveMembersResponse.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.RemoveMembersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.RemoveMembersResponse.displayName = 'proto.somewear.api.v1.RemoveMembersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.TransferDevicesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.TransferDevicesRequest.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.TransferDevicesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.TransferDevicesRequest.displayName = 'proto.somewear.api.v1.TransferDevicesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.TransferDeviceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.TransferDeviceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.TransferDeviceRequest.displayName = 'proto.somewear.api.v1.TransferDeviceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.TransferDevicesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.TransferDevicesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.TransferDevicesResponse.displayName = 'proto.somewear.api.v1.TransferDevicesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.CreateWorkspaceKeyApiRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.CreateWorkspaceKeyApiRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.CreateWorkspaceKeyApiRequest.displayName = 'proto.somewear.api.v1.CreateWorkspaceKeyApiRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.CreateWorkspaceKeyApiResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.CreateWorkspaceKeyApiResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.CreateWorkspaceKeyApiResponse.displayName = 'proto.somewear.api.v1.CreateWorkspaceKeyApiResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.CreateResourceAccountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.CreateResourceAccountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.CreateResourceAccountRequest.displayName = 'proto.somewear.api.v1.CreateResourceAccountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.CreateResourceAccountResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.CreateResourceAccountResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.CreateResourceAccountResponse.displayName = 'proto.somewear.api.v1.CreateResourceAccountResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.UpdateWorkspaceRoleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.UpdateWorkspaceRoleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.UpdateWorkspaceRoleRequest.displayName = 'proto.somewear.api.v1.UpdateWorkspaceRoleRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.UpdateWorkspaceRoleResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.UpdateWorkspaceRoleResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.UpdateWorkspaceRoleResponse.displayName = 'proto.somewear.api.v1.UpdateWorkspaceRoleResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.ArchiveWorkspaceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.ArchiveWorkspaceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.ArchiveWorkspaceRequest.displayName = 'proto.somewear.api.v1.ArchiveWorkspaceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.DeleteWorkspaceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.DeleteWorkspaceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.DeleteWorkspaceRequest.displayName = 'proto.somewear.api.v1.DeleteWorkspaceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.UpdateWorkspaceAccessResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.UpdateWorkspaceAccessResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.UpdateWorkspaceAccessResponse.displayName = 'proto.somewear.api.v1.UpdateWorkspaceAccessResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.LeaveWorkspaceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.LeaveWorkspaceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.LeaveWorkspaceRequest.displayName = 'proto.somewear.api.v1.LeaveWorkspaceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.IssueWorkspaceInviteTokenRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.IssueWorkspaceInviteTokenRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.IssueWorkspaceInviteTokenRequest.displayName = 'proto.somewear.api.v1.IssueWorkspaceInviteTokenRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.IssueWorkspaceInviteTokenResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.IssueWorkspaceInviteTokenResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.IssueWorkspaceInviteTokenResponse.displayName = 'proto.somewear.api.v1.IssueWorkspaceInviteTokenResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.JoinWorkspaceByInviteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.JoinWorkspaceByInviteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.JoinWorkspaceByInviteRequest.displayName = 'proto.somewear.api.v1.JoinWorkspaceByInviteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.JoinWorkspaceByInviteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.JoinWorkspaceByInviteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.JoinWorkspaceByInviteResponse.displayName = 'proto.somewear.api.v1.JoinWorkspaceByInviteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.ToggleWorkspaceIntegrationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.ToggleWorkspaceIntegrationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.ToggleWorkspaceIntegrationRequest.displayName = 'proto.somewear.api.v1.ToggleWorkspaceIntegrationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetDefaultSettingsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.GetDefaultSettingsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetDefaultSettingsRequest.displayName = 'proto.somewear.api.v1.GetDefaultSettingsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetDefaultSettingsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.GetDefaultSettingsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetDefaultSettingsResponse.displayName = 'proto.somewear.api.v1.GetDefaultSettingsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.UpdateDefaultSettingsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.UpdateDefaultSettingsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.UpdateDefaultSettingsRequest.displayName = 'proto.somewear.api.v1.UpdateDefaultSettingsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.ApplyDefaultSettingsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.ApplyDefaultSettingsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.ApplyDefaultSettingsRequest.displayName = 'proto.somewear.api.v1.ApplyDefaultSettingsRequest';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.InviteMembersRequest.repeatedFields_ = [1,3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.InviteMembersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.InviteMembersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.InviteMembersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.InviteMembersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
emailsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
inviteToOrganization: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
identityIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
usernamesList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.InviteMembersRequest}
 */
proto.somewear.api.v1.InviteMembersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.InviteMembersRequest;
  return proto.somewear.api.v1.InviteMembersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.InviteMembersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.InviteMembersRequest}
 */
proto.somewear.api.v1.InviteMembersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addEmails(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInviteToOrganization(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addIdentityIds(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addUsernames(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.InviteMembersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.InviteMembersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.InviteMembersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.InviteMembersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmailsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getInviteToOrganization();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getIdentityIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getUsernamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
};


/**
 * repeated string emails = 1;
 * @return {!Array<string>}
 */
proto.somewear.api.v1.InviteMembersRequest.prototype.getEmailsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.somewear.api.v1.InviteMembersRequest} returns this
 */
proto.somewear.api.v1.InviteMembersRequest.prototype.setEmailsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.somewear.api.v1.InviteMembersRequest} returns this
 */
proto.somewear.api.v1.InviteMembersRequest.prototype.addEmails = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.InviteMembersRequest} returns this
 */
proto.somewear.api.v1.InviteMembersRequest.prototype.clearEmailsList = function() {
  return this.setEmailsList([]);
};


/**
 * optional bool invite_to_organization = 2;
 * @return {boolean}
 */
proto.somewear.api.v1.InviteMembersRequest.prototype.getInviteToOrganization = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.somewear.api.v1.InviteMembersRequest} returns this
 */
proto.somewear.api.v1.InviteMembersRequest.prototype.setInviteToOrganization = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * repeated string identity_ids = 3;
 * @return {!Array<string>}
 */
proto.somewear.api.v1.InviteMembersRequest.prototype.getIdentityIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.somewear.api.v1.InviteMembersRequest} returns this
 */
proto.somewear.api.v1.InviteMembersRequest.prototype.setIdentityIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.somewear.api.v1.InviteMembersRequest} returns this
 */
proto.somewear.api.v1.InviteMembersRequest.prototype.addIdentityIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.InviteMembersRequest} returns this
 */
proto.somewear.api.v1.InviteMembersRequest.prototype.clearIdentityIdsList = function() {
  return this.setIdentityIdsList([]);
};


/**
 * repeated string usernames = 4;
 * @return {!Array<string>}
 */
proto.somewear.api.v1.InviteMembersRequest.prototype.getUsernamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.somewear.api.v1.InviteMembersRequest} returns this
 */
proto.somewear.api.v1.InviteMembersRequest.prototype.setUsernamesList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.somewear.api.v1.InviteMembersRequest} returns this
 */
proto.somewear.api.v1.InviteMembersRequest.prototype.addUsernames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.InviteMembersRequest} returns this
 */
proto.somewear.api.v1.InviteMembersRequest.prototype.clearUsernamesList = function() {
  return this.setUsernamesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.InviteMembersResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.InviteMembersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.InviteMembersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.InviteMembersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.InviteMembersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
usersList: jspb.Message.toObjectList(msg.getUsersList(),
    user_proto_pb.UserResponse.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.InviteMembersResponse}
 */
proto.somewear.api.v1.InviteMembersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.InviteMembersResponse;
  return proto.somewear.api.v1.InviteMembersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.InviteMembersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.InviteMembersResponse}
 */
proto.somewear.api.v1.InviteMembersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new user_proto_pb.UserResponse;
      reader.readMessage(value,user_proto_pb.UserResponse.deserializeBinaryFromReader);
      msg.addUsers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.InviteMembersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.InviteMembersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.InviteMembersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.InviteMembersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      user_proto_pb.UserResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated UserResponse users = 1;
 * @return {!Array<!proto.UserResponse>}
 */
proto.somewear.api.v1.InviteMembersResponse.prototype.getUsersList = function() {
  return /** @type{!Array<!proto.UserResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, user_proto_pb.UserResponse, 1));
};


/**
 * @param {!Array<!proto.UserResponse>} value
 * @return {!proto.somewear.api.v1.InviteMembersResponse} returns this
*/
proto.somewear.api.v1.InviteMembersResponse.prototype.setUsersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.UserResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.UserResponse}
 */
proto.somewear.api.v1.InviteMembersResponse.prototype.addUsers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.UserResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.InviteMembersResponse} returns this
 */
proto.somewear.api.v1.InviteMembersResponse.prototype.clearUsersList = function() {
  return this.setUsersList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.ArchiveMembersRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.ArchiveMembersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.ArchiveMembersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.ArchiveMembersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.ArchiveMembersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.ArchiveMembersRequest}
 */
proto.somewear.api.v1.ArchiveMembersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.ArchiveMembersRequest;
  return proto.somewear.api.v1.ArchiveMembersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.ArchiveMembersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.ArchiveMembersRequest}
 */
proto.somewear.api.v1.ArchiveMembersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addUserIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.ArchiveMembersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.ArchiveMembersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.ArchiveMembersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.ArchiveMembersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * repeated string user_ids = 2;
 * @return {!Array<string>}
 */
proto.somewear.api.v1.ArchiveMembersRequest.prototype.getUserIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.somewear.api.v1.ArchiveMembersRequest} returns this
 */
proto.somewear.api.v1.ArchiveMembersRequest.prototype.setUserIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.somewear.api.v1.ArchiveMembersRequest} returns this
 */
proto.somewear.api.v1.ArchiveMembersRequest.prototype.addUserIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.ArchiveMembersRequest} returns this
 */
proto.somewear.api.v1.ArchiveMembersRequest.prototype.clearUserIdsList = function() {
  return this.setUserIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.ArchiveMembersResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.ArchiveMembersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.ArchiveMembersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.ArchiveMembersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.ArchiveMembersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
usersList: jspb.Message.toObjectList(msg.getUsersList(),
    user_proto_pb.UserResponse.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.ArchiveMembersResponse}
 */
proto.somewear.api.v1.ArchiveMembersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.ArchiveMembersResponse;
  return proto.somewear.api.v1.ArchiveMembersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.ArchiveMembersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.ArchiveMembersResponse}
 */
proto.somewear.api.v1.ArchiveMembersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new user_proto_pb.UserResponse;
      reader.readMessage(value,user_proto_pb.UserResponse.deserializeBinaryFromReader);
      msg.addUsers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.ArchiveMembersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.ArchiveMembersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.ArchiveMembersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.ArchiveMembersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      user_proto_pb.UserResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated UserResponse users = 1;
 * @return {!Array<!proto.UserResponse>}
 */
proto.somewear.api.v1.ArchiveMembersResponse.prototype.getUsersList = function() {
  return /** @type{!Array<!proto.UserResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, user_proto_pb.UserResponse, 1));
};


/**
 * @param {!Array<!proto.UserResponse>} value
 * @return {!proto.somewear.api.v1.ArchiveMembersResponse} returns this
*/
proto.somewear.api.v1.ArchiveMembersResponse.prototype.setUsersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.UserResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.UserResponse}
 */
proto.somewear.api.v1.ArchiveMembersResponse.prototype.addUsers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.UserResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.ArchiveMembersResponse} returns this
 */
proto.somewear.api.v1.ArchiveMembersResponse.prototype.clearUsersList = function() {
  return this.setUsersList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.RemoveMembersRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.RemoveMembersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.RemoveMembersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.RemoveMembersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.RemoveMembersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.RemoveMembersRequest}
 */
proto.somewear.api.v1.RemoveMembersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.RemoveMembersRequest;
  return proto.somewear.api.v1.RemoveMembersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.RemoveMembersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.RemoveMembersRequest}
 */
proto.somewear.api.v1.RemoveMembersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addUserIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.RemoveMembersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.RemoveMembersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.RemoveMembersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.RemoveMembersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string user_ids = 1;
 * @return {!Array<string>}
 */
proto.somewear.api.v1.RemoveMembersRequest.prototype.getUserIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.somewear.api.v1.RemoveMembersRequest} returns this
 */
proto.somewear.api.v1.RemoveMembersRequest.prototype.setUserIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.somewear.api.v1.RemoveMembersRequest} returns this
 */
proto.somewear.api.v1.RemoveMembersRequest.prototype.addUserIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.RemoveMembersRequest} returns this
 */
proto.somewear.api.v1.RemoveMembersRequest.prototype.clearUserIdsList = function() {
  return this.setUserIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.RemoveMembersResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.RemoveMembersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.RemoveMembersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.RemoveMembersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.RemoveMembersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
usersList: jspb.Message.toObjectList(msg.getUsersList(),
    user_proto_pb.UserResponse.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.RemoveMembersResponse}
 */
proto.somewear.api.v1.RemoveMembersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.RemoveMembersResponse;
  return proto.somewear.api.v1.RemoveMembersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.RemoveMembersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.RemoveMembersResponse}
 */
proto.somewear.api.v1.RemoveMembersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new user_proto_pb.UserResponse;
      reader.readMessage(value,user_proto_pb.UserResponse.deserializeBinaryFromReader);
      msg.addUsers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.RemoveMembersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.RemoveMembersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.RemoveMembersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.RemoveMembersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      user_proto_pb.UserResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated UserResponse users = 1;
 * @return {!Array<!proto.UserResponse>}
 */
proto.somewear.api.v1.RemoveMembersResponse.prototype.getUsersList = function() {
  return /** @type{!Array<!proto.UserResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, user_proto_pb.UserResponse, 1));
};


/**
 * @param {!Array<!proto.UserResponse>} value
 * @return {!proto.somewear.api.v1.RemoveMembersResponse} returns this
*/
proto.somewear.api.v1.RemoveMembersResponse.prototype.setUsersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.UserResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.UserResponse}
 */
proto.somewear.api.v1.RemoveMembersResponse.prototype.addUsers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.UserResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.RemoveMembersResponse} returns this
 */
proto.somewear.api.v1.RemoveMembersResponse.prototype.clearUsersList = function() {
  return this.setUsersList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.TransferDevicesRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.TransferDevicesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.TransferDevicesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.TransferDevicesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.TransferDevicesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
requestList: jspb.Message.toObjectList(msg.getRequestList(),
    proto.somewear.api.v1.TransferDeviceRequest.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.TransferDevicesRequest}
 */
proto.somewear.api.v1.TransferDevicesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.TransferDevicesRequest;
  return proto.somewear.api.v1.TransferDevicesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.TransferDevicesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.TransferDevicesRequest}
 */
proto.somewear.api.v1.TransferDevicesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.somewear.api.v1.TransferDeviceRequest;
      reader.readMessage(value,proto.somewear.api.v1.TransferDeviceRequest.deserializeBinaryFromReader);
      msg.addRequest(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.TransferDevicesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.TransferDevicesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.TransferDevicesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.TransferDevicesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.somewear.api.v1.TransferDeviceRequest.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TransferDeviceRequest request = 1;
 * @return {!Array<!proto.somewear.api.v1.TransferDeviceRequest>}
 */
proto.somewear.api.v1.TransferDevicesRequest.prototype.getRequestList = function() {
  return /** @type{!Array<!proto.somewear.api.v1.TransferDeviceRequest>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.somewear.api.v1.TransferDeviceRequest, 1));
};


/**
 * @param {!Array<!proto.somewear.api.v1.TransferDeviceRequest>} value
 * @return {!proto.somewear.api.v1.TransferDevicesRequest} returns this
*/
proto.somewear.api.v1.TransferDevicesRequest.prototype.setRequestList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.somewear.api.v1.TransferDeviceRequest=} opt_value
 * @param {number=} opt_index
 * @return {!proto.somewear.api.v1.TransferDeviceRequest}
 */
proto.somewear.api.v1.TransferDevicesRequest.prototype.addRequest = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.somewear.api.v1.TransferDeviceRequest, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.TransferDevicesRequest} returns this
 */
proto.somewear.api.v1.TransferDevicesRequest.prototype.clearRequestList = function() {
  return this.setRequestList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.TransferDeviceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.TransferDeviceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.TransferDeviceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.TransferDeviceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
deviceSerial: jspb.Message.getFieldWithDefault(msg, 1, ""),
targetWorkspaceId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.TransferDeviceRequest}
 */
proto.somewear.api.v1.TransferDeviceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.TransferDeviceRequest;
  return proto.somewear.api.v1.TransferDeviceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.TransferDeviceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.TransferDeviceRequest}
 */
proto.somewear.api.v1.TransferDeviceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceSerial(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetWorkspaceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.TransferDeviceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.TransferDeviceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.TransferDeviceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.TransferDeviceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDeviceSerial();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTargetWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string device_serial = 1;
 * @return {string}
 */
proto.somewear.api.v1.TransferDeviceRequest.prototype.getDeviceSerial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.TransferDeviceRequest} returns this
 */
proto.somewear.api.v1.TransferDeviceRequest.prototype.setDeviceSerial = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string target_workspace_id = 2;
 * @return {string}
 */
proto.somewear.api.v1.TransferDeviceRequest.prototype.getTargetWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.TransferDeviceRequest} returns this
 */
proto.somewear.api.v1.TransferDeviceRequest.prototype.setTargetWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.TransferDevicesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.TransferDevicesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.TransferDevicesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.TransferDevicesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
request: (f = msg.getRequest()) && proto.somewear.api.v1.TransferDevicesRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.TransferDevicesResponse}
 */
proto.somewear.api.v1.TransferDevicesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.TransferDevicesResponse;
  return proto.somewear.api.v1.TransferDevicesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.TransferDevicesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.TransferDevicesResponse}
 */
proto.somewear.api.v1.TransferDevicesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.somewear.api.v1.TransferDevicesRequest;
      reader.readMessage(value,proto.somewear.api.v1.TransferDevicesRequest.deserializeBinaryFromReader);
      msg.setRequest(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.TransferDevicesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.TransferDevicesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.TransferDevicesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.TransferDevicesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequest();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.somewear.api.v1.TransferDevicesRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional TransferDevicesRequest request = 1;
 * @return {?proto.somewear.api.v1.TransferDevicesRequest}
 */
proto.somewear.api.v1.TransferDevicesResponse.prototype.getRequest = function() {
  return /** @type{?proto.somewear.api.v1.TransferDevicesRequest} */ (
    jspb.Message.getWrapperField(this, proto.somewear.api.v1.TransferDevicesRequest, 1));
};


/**
 * @param {?proto.somewear.api.v1.TransferDevicesRequest|undefined} value
 * @return {!proto.somewear.api.v1.TransferDevicesResponse} returns this
*/
proto.somewear.api.v1.TransferDevicesResponse.prototype.setRequest = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.TransferDevicesResponse} returns this
 */
proto.somewear.api.v1.TransferDevicesResponse.prototype.clearRequest = function() {
  return this.setRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.TransferDevicesResponse.prototype.hasRequest = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.CreateWorkspaceKeyApiRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.CreateWorkspaceKeyApiRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.CreateWorkspaceKeyApiRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CreateWorkspaceKeyApiRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.CreateWorkspaceKeyApiRequest}
 */
proto.somewear.api.v1.CreateWorkspaceKeyApiRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.CreateWorkspaceKeyApiRequest;
  return proto.somewear.api.v1.CreateWorkspaceKeyApiRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.CreateWorkspaceKeyApiRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.CreateWorkspaceKeyApiRequest}
 */
proto.somewear.api.v1.CreateWorkspaceKeyApiRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.CreateWorkspaceKeyApiRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.CreateWorkspaceKeyApiRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.CreateWorkspaceKeyApiRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CreateWorkspaceKeyApiRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.CreateWorkspaceKeyApiResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.CreateWorkspaceKeyApiResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.CreateWorkspaceKeyApiResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CreateWorkspaceKeyApiResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
key: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.CreateWorkspaceKeyApiResponse}
 */
proto.somewear.api.v1.CreateWorkspaceKeyApiResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.CreateWorkspaceKeyApiResponse;
  return proto.somewear.api.v1.CreateWorkspaceKeyApiResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.CreateWorkspaceKeyApiResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.CreateWorkspaceKeyApiResponse}
 */
proto.somewear.api.v1.CreateWorkspaceKeyApiResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.CreateWorkspaceKeyApiResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.CreateWorkspaceKeyApiResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.CreateWorkspaceKeyApiResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CreateWorkspaceKeyApiResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string key = 1;
 * @return {string}
 */
proto.somewear.api.v1.CreateWorkspaceKeyApiResponse.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.CreateWorkspaceKeyApiResponse} returns this
 */
proto.somewear.api.v1.CreateWorkspaceKeyApiResponse.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.CreateResourceAccountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.CreateResourceAccountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.CreateResourceAccountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CreateResourceAccountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
addToOrg: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.CreateResourceAccountRequest}
 */
proto.somewear.api.v1.CreateResourceAccountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.CreateResourceAccountRequest;
  return proto.somewear.api.v1.CreateResourceAccountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.CreateResourceAccountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.CreateResourceAccountRequest}
 */
proto.somewear.api.v1.CreateResourceAccountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAddToOrg(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.CreateResourceAccountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.CreateResourceAccountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.CreateResourceAccountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CreateResourceAccountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAddToOrg();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.somewear.api.v1.CreateResourceAccountRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.CreateResourceAccountRequest} returns this
 */
proto.somewear.api.v1.CreateResourceAccountRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool add_to_org = 2;
 * @return {boolean}
 */
proto.somewear.api.v1.CreateResourceAccountRequest.prototype.getAddToOrg = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.somewear.api.v1.CreateResourceAccountRequest} returns this
 */
proto.somewear.api.v1.CreateResourceAccountRequest.prototype.setAddToOrg = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.CreateResourceAccountResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.CreateResourceAccountResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.CreateResourceAccountResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CreateResourceAccountResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
user: (f = msg.getUser()) && user_proto_pb.UserResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.CreateResourceAccountResponse}
 */
proto.somewear.api.v1.CreateResourceAccountResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.CreateResourceAccountResponse;
  return proto.somewear.api.v1.CreateResourceAccountResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.CreateResourceAccountResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.CreateResourceAccountResponse}
 */
proto.somewear.api.v1.CreateResourceAccountResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new user_proto_pb.UserResponse;
      reader.readMessage(value,user_proto_pb.UserResponse.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.CreateResourceAccountResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.CreateResourceAccountResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.CreateResourceAccountResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CreateResourceAccountResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      user_proto_pb.UserResponse.serializeBinaryToWriter
    );
  }
};


/**
 * optional UserResponse user = 1;
 * @return {?proto.UserResponse}
 */
proto.somewear.api.v1.CreateResourceAccountResponse.prototype.getUser = function() {
  return /** @type{?proto.UserResponse} */ (
    jspb.Message.getWrapperField(this, user_proto_pb.UserResponse, 1));
};


/**
 * @param {?proto.UserResponse|undefined} value
 * @return {!proto.somewear.api.v1.CreateResourceAccountResponse} returns this
*/
proto.somewear.api.v1.CreateResourceAccountResponse.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.CreateResourceAccountResponse} returns this
 */
proto.somewear.api.v1.CreateResourceAccountResponse.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.CreateResourceAccountResponse.prototype.hasUser = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.UpdateWorkspaceRoleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.UpdateWorkspaceRoleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.UpdateWorkspaceRoleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.UpdateWorkspaceRoleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
role: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.UpdateWorkspaceRoleRequest}
 */
proto.somewear.api.v1.UpdateWorkspaceRoleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.UpdateWorkspaceRoleRequest;
  return proto.somewear.api.v1.UpdateWorkspaceRoleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.UpdateWorkspaceRoleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.UpdateWorkspaceRoleRequest}
 */
proto.somewear.api.v1.UpdateWorkspaceRoleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {!proto.WorkspaceRole} */ (reader.readEnum());
      msg.setRole(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.UpdateWorkspaceRoleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.UpdateWorkspaceRoleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.UpdateWorkspaceRoleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.UpdateWorkspaceRoleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRole();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.somewear.api.v1.UpdateWorkspaceRoleRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.UpdateWorkspaceRoleRequest} returns this
 */
proto.somewear.api.v1.UpdateWorkspaceRoleRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional WorkspaceRole role = 2;
 * @return {!proto.WorkspaceRole}
 */
proto.somewear.api.v1.UpdateWorkspaceRoleRequest.prototype.getRole = function() {
  return /** @type {!proto.WorkspaceRole} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.WorkspaceRole} value
 * @return {!proto.somewear.api.v1.UpdateWorkspaceRoleRequest} returns this
 */
proto.somewear.api.v1.UpdateWorkspaceRoleRequest.prototype.setRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.UpdateWorkspaceRoleResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.UpdateWorkspaceRoleResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.UpdateWorkspaceRoleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.UpdateWorkspaceRoleResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
user: (f = msg.getUser()) && user_proto_pb.UserResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.UpdateWorkspaceRoleResponse}
 */
proto.somewear.api.v1.UpdateWorkspaceRoleResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.UpdateWorkspaceRoleResponse;
  return proto.somewear.api.v1.UpdateWorkspaceRoleResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.UpdateWorkspaceRoleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.UpdateWorkspaceRoleResponse}
 */
proto.somewear.api.v1.UpdateWorkspaceRoleResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new user_proto_pb.UserResponse;
      reader.readMessage(value,user_proto_pb.UserResponse.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.UpdateWorkspaceRoleResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.UpdateWorkspaceRoleResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.UpdateWorkspaceRoleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.UpdateWorkspaceRoleResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      user_proto_pb.UserResponse.serializeBinaryToWriter
    );
  }
};


/**
 * optional UserResponse user = 1;
 * @return {?proto.UserResponse}
 */
proto.somewear.api.v1.UpdateWorkspaceRoleResponse.prototype.getUser = function() {
  return /** @type{?proto.UserResponse} */ (
    jspb.Message.getWrapperField(this, user_proto_pb.UserResponse, 1));
};


/**
 * @param {?proto.UserResponse|undefined} value
 * @return {!proto.somewear.api.v1.UpdateWorkspaceRoleResponse} returns this
*/
proto.somewear.api.v1.UpdateWorkspaceRoleResponse.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.UpdateWorkspaceRoleResponse} returns this
 */
proto.somewear.api.v1.UpdateWorkspaceRoleResponse.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.UpdateWorkspaceRoleResponse.prototype.hasUser = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.ArchiveWorkspaceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.ArchiveWorkspaceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.ArchiveWorkspaceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.ArchiveWorkspaceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.ArchiveWorkspaceRequest}
 */
proto.somewear.api.v1.ArchiveWorkspaceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.ArchiveWorkspaceRequest;
  return proto.somewear.api.v1.ArchiveWorkspaceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.ArchiveWorkspaceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.ArchiveWorkspaceRequest}
 */
proto.somewear.api.v1.ArchiveWorkspaceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.ArchiveWorkspaceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.ArchiveWorkspaceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.ArchiveWorkspaceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.ArchiveWorkspaceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.somewear.api.v1.ArchiveWorkspaceRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.ArchiveWorkspaceRequest} returns this
 */
proto.somewear.api.v1.ArchiveWorkspaceRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.DeleteWorkspaceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.DeleteWorkspaceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.DeleteWorkspaceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.DeleteWorkspaceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.DeleteWorkspaceRequest}
 */
proto.somewear.api.v1.DeleteWorkspaceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.DeleteWorkspaceRequest;
  return proto.somewear.api.v1.DeleteWorkspaceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.DeleteWorkspaceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.DeleteWorkspaceRequest}
 */
proto.somewear.api.v1.DeleteWorkspaceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.DeleteWorkspaceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.DeleteWorkspaceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.DeleteWorkspaceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.DeleteWorkspaceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.somewear.api.v1.DeleteWorkspaceRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.DeleteWorkspaceRequest} returns this
 */
proto.somewear.api.v1.DeleteWorkspaceRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.UpdateWorkspaceAccessResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.UpdateWorkspaceAccessResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.UpdateWorkspaceAccessResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.UpdateWorkspaceAccessResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
access: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.UpdateWorkspaceAccessResponse}
 */
proto.somewear.api.v1.UpdateWorkspaceAccessResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.UpdateWorkspaceAccessResponse;
  return proto.somewear.api.v1.UpdateWorkspaceAccessResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.UpdateWorkspaceAccessResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.UpdateWorkspaceAccessResponse}
 */
proto.somewear.api.v1.UpdateWorkspaceAccessResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.WorkspaceAccess} */ (reader.readEnum());
      msg.setAccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.UpdateWorkspaceAccessResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.UpdateWorkspaceAccessResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.UpdateWorkspaceAccessResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.UpdateWorkspaceAccessResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccess();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.somewear.api.v1.UpdateWorkspaceAccessResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.UpdateWorkspaceAccessResponse} returns this
 */
proto.somewear.api.v1.UpdateWorkspaceAccessResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional WorkspaceAccess access = 2;
 * @return {!proto.WorkspaceAccess}
 */
proto.somewear.api.v1.UpdateWorkspaceAccessResponse.prototype.getAccess = function() {
  return /** @type {!proto.WorkspaceAccess} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.WorkspaceAccess} value
 * @return {!proto.somewear.api.v1.UpdateWorkspaceAccessResponse} returns this
 */
proto.somewear.api.v1.UpdateWorkspaceAccessResponse.prototype.setAccess = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.LeaveWorkspaceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.LeaveWorkspaceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.LeaveWorkspaceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.LeaveWorkspaceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.LeaveWorkspaceRequest}
 */
proto.somewear.api.v1.LeaveWorkspaceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.LeaveWorkspaceRequest;
  return proto.somewear.api.v1.LeaveWorkspaceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.LeaveWorkspaceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.LeaveWorkspaceRequest}
 */
proto.somewear.api.v1.LeaveWorkspaceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.LeaveWorkspaceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.LeaveWorkspaceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.LeaveWorkspaceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.LeaveWorkspaceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.somewear.api.v1.LeaveWorkspaceRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.LeaveWorkspaceRequest} returns this
 */
proto.somewear.api.v1.LeaveWorkspaceRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.IssueWorkspaceInviteTokenRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.IssueWorkspaceInviteTokenRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.IssueWorkspaceInviteTokenRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.IssueWorkspaceInviteTokenRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
workspaceId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.IssueWorkspaceInviteTokenRequest}
 */
proto.somewear.api.v1.IssueWorkspaceInviteTokenRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.IssueWorkspaceInviteTokenRequest;
  return proto.somewear.api.v1.IssueWorkspaceInviteTokenRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.IssueWorkspaceInviteTokenRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.IssueWorkspaceInviteTokenRequest}
 */
proto.somewear.api.v1.IssueWorkspaceInviteTokenRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.IssueWorkspaceInviteTokenRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.IssueWorkspaceInviteTokenRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.IssueWorkspaceInviteTokenRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.IssueWorkspaceInviteTokenRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string workspace_id = 1;
 * @return {string}
 */
proto.somewear.api.v1.IssueWorkspaceInviteTokenRequest.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.IssueWorkspaceInviteTokenRequest} returns this
 */
proto.somewear.api.v1.IssueWorkspaceInviteTokenRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.IssueWorkspaceInviteTokenResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.IssueWorkspaceInviteTokenResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.IssueWorkspaceInviteTokenResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.IssueWorkspaceInviteTokenResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
token: jspb.Message.getFieldWithDefault(msg, 1, ""),
workspaceName: jspb.Message.getFieldWithDefault(msg, 2, ""),
url: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.IssueWorkspaceInviteTokenResponse}
 */
proto.somewear.api.v1.IssueWorkspaceInviteTokenResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.IssueWorkspaceInviteTokenResponse;
  return proto.somewear.api.v1.IssueWorkspaceInviteTokenResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.IssueWorkspaceInviteTokenResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.IssueWorkspaceInviteTokenResponse}
 */
proto.somewear.api.v1.IssueWorkspaceInviteTokenResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.IssueWorkspaceInviteTokenResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.IssueWorkspaceInviteTokenResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.IssueWorkspaceInviteTokenResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.IssueWorkspaceInviteTokenResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getWorkspaceName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string token = 1;
 * @return {string}
 */
proto.somewear.api.v1.IssueWorkspaceInviteTokenResponse.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.IssueWorkspaceInviteTokenResponse} returns this
 */
proto.somewear.api.v1.IssueWorkspaceInviteTokenResponse.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string workspace_name = 2;
 * @return {string}
 */
proto.somewear.api.v1.IssueWorkspaceInviteTokenResponse.prototype.getWorkspaceName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.IssueWorkspaceInviteTokenResponse} returns this
 */
proto.somewear.api.v1.IssueWorkspaceInviteTokenResponse.prototype.setWorkspaceName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string url = 3;
 * @return {string}
 */
proto.somewear.api.v1.IssueWorkspaceInviteTokenResponse.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.IssueWorkspaceInviteTokenResponse} returns this
 */
proto.somewear.api.v1.IssueWorkspaceInviteTokenResponse.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.JoinWorkspaceByInviteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.JoinWorkspaceByInviteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.JoinWorkspaceByInviteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.JoinWorkspaceByInviteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
token: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.JoinWorkspaceByInviteRequest}
 */
proto.somewear.api.v1.JoinWorkspaceByInviteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.JoinWorkspaceByInviteRequest;
  return proto.somewear.api.v1.JoinWorkspaceByInviteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.JoinWorkspaceByInviteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.JoinWorkspaceByInviteRequest}
 */
proto.somewear.api.v1.JoinWorkspaceByInviteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.JoinWorkspaceByInviteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.JoinWorkspaceByInviteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.JoinWorkspaceByInviteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.JoinWorkspaceByInviteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string token = 1;
 * @return {string}
 */
proto.somewear.api.v1.JoinWorkspaceByInviteRequest.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.JoinWorkspaceByInviteRequest} returns this
 */
proto.somewear.api.v1.JoinWorkspaceByInviteRequest.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.JoinWorkspaceByInviteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.JoinWorkspaceByInviteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.JoinWorkspaceByInviteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.JoinWorkspaceByInviteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
workspace: (f = msg.getWorkspace()) && user_proto_pb.WorkspaceResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.JoinWorkspaceByInviteResponse}
 */
proto.somewear.api.v1.JoinWorkspaceByInviteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.JoinWorkspaceByInviteResponse;
  return proto.somewear.api.v1.JoinWorkspaceByInviteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.JoinWorkspaceByInviteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.JoinWorkspaceByInviteResponse}
 */
proto.somewear.api.v1.JoinWorkspaceByInviteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new user_proto_pb.WorkspaceResponse;
      reader.readMessage(value,user_proto_pb.WorkspaceResponse.deserializeBinaryFromReader);
      msg.setWorkspace(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.JoinWorkspaceByInviteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.JoinWorkspaceByInviteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.JoinWorkspaceByInviteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.JoinWorkspaceByInviteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspace();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      user_proto_pb.WorkspaceResponse.serializeBinaryToWriter
    );
  }
};


/**
 * optional WorkspaceResponse workspace = 1;
 * @return {?proto.WorkspaceResponse}
 */
proto.somewear.api.v1.JoinWorkspaceByInviteResponse.prototype.getWorkspace = function() {
  return /** @type{?proto.WorkspaceResponse} */ (
    jspb.Message.getWrapperField(this, user_proto_pb.WorkspaceResponse, 1));
};


/**
 * @param {?proto.WorkspaceResponse|undefined} value
 * @return {!proto.somewear.api.v1.JoinWorkspaceByInviteResponse} returns this
*/
proto.somewear.api.v1.JoinWorkspaceByInviteResponse.prototype.setWorkspace = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.JoinWorkspaceByInviteResponse} returns this
 */
proto.somewear.api.v1.JoinWorkspaceByInviteResponse.prototype.clearWorkspace = function() {
  return this.setWorkspace(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.JoinWorkspaceByInviteResponse.prototype.hasWorkspace = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.ToggleWorkspaceIntegrationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.ToggleWorkspaceIntegrationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.ToggleWorkspaceIntegrationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.ToggleWorkspaceIntegrationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
workspaceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
identityId: jspb.Message.getFieldWithDefault(msg, 2, ""),
enableIntegration: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.ToggleWorkspaceIntegrationRequest}
 */
proto.somewear.api.v1.ToggleWorkspaceIntegrationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.ToggleWorkspaceIntegrationRequest;
  return proto.somewear.api.v1.ToggleWorkspaceIntegrationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.ToggleWorkspaceIntegrationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.ToggleWorkspaceIntegrationRequest}
 */
proto.somewear.api.v1.ToggleWorkspaceIntegrationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentityId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableIntegration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.ToggleWorkspaceIntegrationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.ToggleWorkspaceIntegrationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.ToggleWorkspaceIntegrationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.ToggleWorkspaceIntegrationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIdentityId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEnableIntegration();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string workspace_id = 1;
 * @return {string}
 */
proto.somewear.api.v1.ToggleWorkspaceIntegrationRequest.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.ToggleWorkspaceIntegrationRequest} returns this
 */
proto.somewear.api.v1.ToggleWorkspaceIntegrationRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string identity_id = 2;
 * @return {string}
 */
proto.somewear.api.v1.ToggleWorkspaceIntegrationRequest.prototype.getIdentityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.ToggleWorkspaceIntegrationRequest} returns this
 */
proto.somewear.api.v1.ToggleWorkspaceIntegrationRequest.prototype.setIdentityId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool enable_integration = 3;
 * @return {boolean}
 */
proto.somewear.api.v1.ToggleWorkspaceIntegrationRequest.prototype.getEnableIntegration = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.somewear.api.v1.ToggleWorkspaceIntegrationRequest} returns this
 */
proto.somewear.api.v1.ToggleWorkspaceIntegrationRequest.prototype.setEnableIntegration = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetDefaultSettingsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetDefaultSettingsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetDefaultSettingsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetDefaultSettingsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
workspaceId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetDefaultSettingsRequest}
 */
proto.somewear.api.v1.GetDefaultSettingsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetDefaultSettingsRequest;
  return proto.somewear.api.v1.GetDefaultSettingsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetDefaultSettingsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetDefaultSettingsRequest}
 */
proto.somewear.api.v1.GetDefaultSettingsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetDefaultSettingsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetDefaultSettingsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetDefaultSettingsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetDefaultSettingsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string workspace_id = 1;
 * @return {string}
 */
proto.somewear.api.v1.GetDefaultSettingsRequest.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.GetDefaultSettingsRequest} returns this
 */
proto.somewear.api.v1.GetDefaultSettingsRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetDefaultSettingsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetDefaultSettingsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetDefaultSettingsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetDefaultSettingsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
workspace: (f = msg.getWorkspace()) && user_proto_pb.WorkspaceResponse.toObject(includeInstance, f),
settings: (f = msg.getSettings()) && workspace_default_settings_proto_pb.WorkspaceDefaultSettings.toObject(includeInstance, f),
lastUpdated: (f = msg.getLastUpdated()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f),
applyToDevicesIsPreferred: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetDefaultSettingsResponse}
 */
proto.somewear.api.v1.GetDefaultSettingsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetDefaultSettingsResponse;
  return proto.somewear.api.v1.GetDefaultSettingsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetDefaultSettingsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetDefaultSettingsResponse}
 */
proto.somewear.api.v1.GetDefaultSettingsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new user_proto_pb.WorkspaceResponse;
      reader.readMessage(value,user_proto_pb.WorkspaceResponse.deserializeBinaryFromReader);
      msg.setWorkspace(value);
      break;
    case 2:
      var value = new workspace_default_settings_proto_pb.WorkspaceDefaultSettings;
      reader.readMessage(value,workspace_default_settings_proto_pb.WorkspaceDefaultSettings.deserializeBinaryFromReader);
      msg.setSettings(value);
      break;
    case 3:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastUpdated(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setApplyToDevicesIsPreferred(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetDefaultSettingsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetDefaultSettingsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetDefaultSettingsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetDefaultSettingsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspace();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      user_proto_pb.WorkspaceResponse.serializeBinaryToWriter
    );
  }
  f = message.getSettings();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      workspace_default_settings_proto_pb.WorkspaceDefaultSettings.serializeBinaryToWriter
    );
  }
  f = message.getLastUpdated();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getApplyToDevicesIsPreferred();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional WorkspaceResponse workspace = 1;
 * @return {?proto.WorkspaceResponse}
 */
proto.somewear.api.v1.GetDefaultSettingsResponse.prototype.getWorkspace = function() {
  return /** @type{?proto.WorkspaceResponse} */ (
    jspb.Message.getWrapperField(this, user_proto_pb.WorkspaceResponse, 1));
};


/**
 * @param {?proto.WorkspaceResponse|undefined} value
 * @return {!proto.somewear.api.v1.GetDefaultSettingsResponse} returns this
*/
proto.somewear.api.v1.GetDefaultSettingsResponse.prototype.setWorkspace = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.GetDefaultSettingsResponse} returns this
 */
proto.somewear.api.v1.GetDefaultSettingsResponse.prototype.clearWorkspace = function() {
  return this.setWorkspace(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.GetDefaultSettingsResponse.prototype.hasWorkspace = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional WorkspaceDefaultSettings settings = 2;
 * @return {?proto.WorkspaceDefaultSettings}
 */
proto.somewear.api.v1.GetDefaultSettingsResponse.prototype.getSettings = function() {
  return /** @type{?proto.WorkspaceDefaultSettings} */ (
    jspb.Message.getWrapperField(this, workspace_default_settings_proto_pb.WorkspaceDefaultSettings, 2));
};


/**
 * @param {?proto.WorkspaceDefaultSettings|undefined} value
 * @return {!proto.somewear.api.v1.GetDefaultSettingsResponse} returns this
*/
proto.somewear.api.v1.GetDefaultSettingsResponse.prototype.setSettings = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.GetDefaultSettingsResponse} returns this
 */
proto.somewear.api.v1.GetDefaultSettingsResponse.prototype.clearSettings = function() {
  return this.setSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.GetDefaultSettingsResponse.prototype.hasSettings = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Timestamp last_updated = 3;
 * @return {?proto.Timestamp}
 */
proto.somewear.api.v1.GetDefaultSettingsResponse.prototype.getLastUpdated = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 3));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.somewear.api.v1.GetDefaultSettingsResponse} returns this
*/
proto.somewear.api.v1.GetDefaultSettingsResponse.prototype.setLastUpdated = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.GetDefaultSettingsResponse} returns this
 */
proto.somewear.api.v1.GetDefaultSettingsResponse.prototype.clearLastUpdated = function() {
  return this.setLastUpdated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.GetDefaultSettingsResponse.prototype.hasLastUpdated = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool apply_to_devices_is_preferred = 4;
 * @return {boolean}
 */
proto.somewear.api.v1.GetDefaultSettingsResponse.prototype.getApplyToDevicesIsPreferred = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.somewear.api.v1.GetDefaultSettingsResponse} returns this
 */
proto.somewear.api.v1.GetDefaultSettingsResponse.prototype.setApplyToDevicesIsPreferred = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.UpdateDefaultSettingsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.UpdateDefaultSettingsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.UpdateDefaultSettingsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.UpdateDefaultSettingsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
workspaceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
settings: (f = msg.getSettings()) && workspace_default_settings_proto_pb.WorkspaceDefaultSettings.toObject(includeInstance, f),
applyToDevices: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.UpdateDefaultSettingsRequest}
 */
proto.somewear.api.v1.UpdateDefaultSettingsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.UpdateDefaultSettingsRequest;
  return proto.somewear.api.v1.UpdateDefaultSettingsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.UpdateDefaultSettingsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.UpdateDefaultSettingsRequest}
 */
proto.somewear.api.v1.UpdateDefaultSettingsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    case 2:
      var value = new workspace_default_settings_proto_pb.WorkspaceDefaultSettings;
      reader.readMessage(value,workspace_default_settings_proto_pb.WorkspaceDefaultSettings.deserializeBinaryFromReader);
      msg.setSettings(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setApplyToDevices(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.UpdateDefaultSettingsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.UpdateDefaultSettingsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.UpdateDefaultSettingsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.UpdateDefaultSettingsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSettings();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      workspace_default_settings_proto_pb.WorkspaceDefaultSettings.serializeBinaryToWriter
    );
  }
  f = message.getApplyToDevices();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string workspace_id = 1;
 * @return {string}
 */
proto.somewear.api.v1.UpdateDefaultSettingsRequest.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.UpdateDefaultSettingsRequest} returns this
 */
proto.somewear.api.v1.UpdateDefaultSettingsRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional WorkspaceDefaultSettings settings = 2;
 * @return {?proto.WorkspaceDefaultSettings}
 */
proto.somewear.api.v1.UpdateDefaultSettingsRequest.prototype.getSettings = function() {
  return /** @type{?proto.WorkspaceDefaultSettings} */ (
    jspb.Message.getWrapperField(this, workspace_default_settings_proto_pb.WorkspaceDefaultSettings, 2));
};


/**
 * @param {?proto.WorkspaceDefaultSettings|undefined} value
 * @return {!proto.somewear.api.v1.UpdateDefaultSettingsRequest} returns this
*/
proto.somewear.api.v1.UpdateDefaultSettingsRequest.prototype.setSettings = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.UpdateDefaultSettingsRequest} returns this
 */
proto.somewear.api.v1.UpdateDefaultSettingsRequest.prototype.clearSettings = function() {
  return this.setSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.UpdateDefaultSettingsRequest.prototype.hasSettings = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool apply_to_devices = 3;
 * @return {boolean}
 */
proto.somewear.api.v1.UpdateDefaultSettingsRequest.prototype.getApplyToDevices = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.somewear.api.v1.UpdateDefaultSettingsRequest} returns this
 */
proto.somewear.api.v1.UpdateDefaultSettingsRequest.prototype.setApplyToDevices = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.ApplyDefaultSettingsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.ApplyDefaultSettingsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.ApplyDefaultSettingsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.ApplyDefaultSettingsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
workspaceId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.ApplyDefaultSettingsRequest}
 */
proto.somewear.api.v1.ApplyDefaultSettingsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.ApplyDefaultSettingsRequest;
  return proto.somewear.api.v1.ApplyDefaultSettingsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.ApplyDefaultSettingsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.ApplyDefaultSettingsRequest}
 */
proto.somewear.api.v1.ApplyDefaultSettingsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.ApplyDefaultSettingsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.ApplyDefaultSettingsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.ApplyDefaultSettingsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.ApplyDefaultSettingsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string workspace_id = 1;
 * @return {string}
 */
proto.somewear.api.v1.ApplyDefaultSettingsRequest.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.ApplyDefaultSettingsRequest} returns this
 */
proto.somewear.api.v1.ApplyDefaultSettingsRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.somewear.api.v1);
